import langs from './lang/index.js';

export const makeItems = lang => {
  const k = langs[lang];

  return {
    tipuriClient: [
      {type: 'casnic', anre_type: 'Casnic', label: k.tip_client_casnic},
      {type: 'noncasnic', anre_type: 'Noncasnic', label: k.tip_client_non_casnic},
    ],
    modalitatiRacordare: [
      {type: 'sistem_de_distributie', anre_type: 'Sistem de distributie', label: k.modalitate_racordare_sistem_distributie},
      {type: 'sistem_de_transport', anre_type: 'Sistem de transport', label: k.modalitate_racordare_sistem_transport},
      {type: 'amonte', anre_type: 'Conducta de alimentare din amonte', label: k.modalitate_racordare_amonte},
    ],
    transeeDeConsum: [
      {type: 'b1', anre_type: 'C1 - Client cu consum anual mai mic sau egal cu 280 MWh', label: k.transee_de_consum_b1, filter: ['sistem_de_distributie']},
      {type: 'b2', anre_type: 'C2 - Client cu consum anual intre 281 MWh si 2800 MWh', label: k.transee_de_consum_b2, filter: ['sistem_de_distributie']},
      {type: 'b3', anre_type: 'C3 - Client cu consum anual intre 2801 MWh si 28000 MWh', label: k.transee_de_consum_b3, filter: ['sistem_de_distributie']},
      {type: 'b4', anre_type: 'C4 - Client cu consum anual intre 28001 MWh si 280 000 MWh', label: k.transee_de_consum_b4, filter: ['sistem_de_distributie']},
      {type: 'b5', anre_type: 'C5 - Client cu consum anual de peste 280 000 MWh', label: k.transee_de_consum_b5, filter: ['sistem_de_distributie']},
    ],
    tipuriPreturiUnitare: [
      {type: 'cu_reglementate', anre_type: 'Cu servicii reglementate incluse', label: k.tip_pret_unitar_cu_reglementate},
      {type: 'fara_reglementate', anre_type: 'Fara servicii reglementate incluse ', label: k.tip_pret_unitar_fara_reglementate}
    ],
    termeneDePlata: [
      {type: '', anre_type: 'oricare', label: k.termen_de_plata_oricare},
      {type: 'pana_15', anre_type: 'mai mic sau egal cu 15 zile', label: k.termen_de_plata_pana_15},
      {type: '15_30', anre_type: 'intre 16 si 29 zile', label: k.termen_de_plata_15_30},
      {type: 'peste_30', anre_type: 'mai mare sau egal cu 30 zile', label: k.termen_de_plata_peste_30},
    ],
    moduriTransmitereFactura: [
      {type: '', anre_type: 'Oricare', label: k.mod_transmitere_factura_oricare, color: 'red'},
      {type: 'tip', anre_type: 'tiparit', label: k.mod_transmitere_factura_electronica, color: 'red'},
      {type: 'elec', anre_type: 'electronic', label: k.mod_transmitere_factura_tiparita, color: 'green'}
    ],
    durateContract: [
      {type: '', anre_type: 'oricare', label: k.durata_contractului_oricare},
      {type: 'nedeterminata', anre_type: 'Nedeterminată', label: k.durata_contractului_nedeterminata},
      {type: '6', anre_type: 'mai mică de 12 luni', label: k.durata_contractului_6},
      {type: '12', anre_type: ' 12 luni', label: k.durata_contractului_12},
      {type: '24', anre_type: 'intre 13 şi 24 luni', label: k.durata_contractului_24},
      {type: '36', anre_type: 'mai mare de 24 luni', label: k.durata_contractului_36},
    ],
    garantii: [
      {type: '', anre_type: 'oricare', label: k.garantii_oricare},
      {type: 'cu garantii', anre_type: 'cu garantii', label: k.garantii_cu_garantii},
      {type: 'fara garantii', anre_type: 'fara garantii', label: k.garantii_fara_garantii},
    ],
    tipuriOferte: [
      {type: '', anre_type: 'Oricare', label: k.tip_oferta_oricare},
      {type: 1, anre_type: 'Oferta simpla', label: k.tip_oferta_simpla},
      {type: 2, anre_type: 'Oferta la pachet cu o oferta de Energie Electrica', label: k.tip_oferta_la_pachet},
    ],
    tipuriPretOferte: [
      {type: '', anre_type: 'Oricare', label: k.tip_pret_oferta_oricare},
      {type: 1, anre_type: 'Pret fix', label: k.tip_pret_oferta_fix},
      {type: 2, anre_type: 'Pret variabil', label: k.tip_pret_oferta_variabil},
      {type: 3, anre_type: 'Pret mixt', label: k.tip_pret_oferta_mixt},
      {type: 4, anre_type: 'Pret variabil bazat pe preturi SPOT', label: k.tip_pret_oferta_variabil_spot},
      {type: 5, anre_type: 'Pret variabil bazat pe preturi ANGRO', label: k.tip_pret_oferta_variabil_angro},
      {type: 6, anre_type: 'Pret maxim', label: k.tip_pret_oferta_maxim},
      {type: 7, anre_type: 'Pret variabil bazat pe un Index variabil', label: k.tip_pret_oferta_index_variabil},
    ],
    suplimentarComponenteFixe: [
      {type: '', anre_type: 'oricare', label: k.suplimentar_componenta_fixa_oricare},
      {type: 1, anre_type: 'da', label: k.suplimentar_componenta_fixa_da},
      {type: 2, anre_type: 'nu', label: k.suplimentar_componenta_fixa_nu},
    ],
    frecventeEmitereFactura: [
      {type: '', anre_type: 'oricare', label: k.frecventa_emitere_factura_oricare},
      {type: 1, anre_type: 'lunar', label: k.frecventa_emitere_factura_lunara},
      {type: 2, anre_type: 'la 2 luni', label: k.frecventa_emitere_factura_2_luni},
      {type: 3, anre_type: 'la 3 luni', label: k.frecventa_emitere_factura_3_luni},
    ],
  };
};

const makeForm = (lang, vm) => {
  const items = makeItems(lang);
  const k = langs[lang];

  const rules = {
    tip_client: [
      v => v === undefined ? k.tip_client_rule_required : true,
      v => v && items.tipuriClient.includes(v) ? true : k.tip_client_rule_in,
    ],
    modalitate_racordare: [
      v => v === undefined ? k.modalitate_racordare_rule_required : true,
      v => v && items.modalitatiRacordare.includes(v) ? true : k.modalitate_racordare_rule_in,
    ],
    tip_pret_unitar: [
      v => v === undefined ? k.tip_pret_unitar_rule_required : true,
      v => v && items.tipuriPreturiUnitare.includes(v) ? true : k.tip_pret_unitar_rule_in,
    ],
    transee_de_consum: [
      v => v === undefined ? k.transee_de_consum_rule_required : true,
      v => v && items.transeeDeConsum.includes(v) ? true : k.transee_de_consum_rule_in,
    ],
    id_judet: [
      v => v === undefined ? k.judet_rule_required : true,
    ],
    localitate: [
      v => v === undefined ? k.localitate_rule_required : true,
    ],
    modul_transmitere_factura: [
      v => v && items.moduriTransmitereFactura.includes(v) ? true : k.mod_transmitere_factura_rule_in,
    ],
    termen_plata: [
      v => v === undefined || items.termeneDePlata.includes(v) ? true : k.termen_plata_rule_in
    ],
    durata_contractului: [
      v => v === undefined || items.durateContract.includes(v) ? true : k.durata_contractului_rule_in
    ],
    garantii: [
      v => v === undefined || items.garantii.includes(v) ? true : k.garantii_rule_in
    ],
    pret_furnizare_mwh: [
      v => v.trim() === '' && vm.fields.consum_mwh.value !== '' ? k.pret_furnizare_mwh_rule_required_with : true,
      v => v && '' + parseFloat(v) !== v ? k.pret_furnizare_mwh_rule_number : true
    ],
    consum_mwh: [
      v => v.trim() === '' && vm.fields.pret_furnizare_mwh.value !== '' ? k.consum_mwh_rule_required_with : true,
      v => v && '' + parseFloat(v) !== v ? k.consum_mwh_rule_number : true
    ],
    data_start_aplicare: [
      v => v === '' ? k.data_start_aplicare_rule_required : true,
    ],
    tip_oferta: [
      v => v === undefined || items.tipuriOferte.includes(v) ? true : k.tip_oferta_rule_in
    ],
    tip_pret_oferta: [
      v => v === undefined || items.tipuriPretOferte.includes(v) ? true : k.tip_pret_oferta_rule_in
    ],
    suplimentar_componenta_fixa: [
      v => v === undefined || items.suplimentarComponenteFixe.includes(v) ? true : k.suplimentar_componenta_fixa_rule_in
    ],
    frecventa_emitere_factura: [
      v => v === undefined || items.frecventeEmitereFactura.includes(v) ? true : k.frecventa_emitere_factura_rule_in
    ],
    componenta_fixa: [
      v => v && '' + parseFloat(v) !== v ? k.componenta_fixa_rule_number : true
    ],
  };

  return {
    items,
    rules,
    keywords: k
  };
};

export default makeForm;
